import React from 'react';

import { Button, Tooltip, Icons } from '~/components';

const ButtonLinkAnexo = ({
  onClick,
  'aria-label': ariaLabel = 'Abrir link do anexo',
}) => (
  <Tooltip title="Acessar">
    <Button
      shape="circle"
      onClick={onClick}
      type="primary"
      icon={<Icons.LinkOutlined aria-hidden />}
      style={{ margin: '9px' }}
      aria-label={ariaLabel}
    />
  </Tooltip>
);

export default ButtonLinkAnexo;
